import React from 'react';
import tf from '../styling/images/transformer/tf.jpg';

const Transformer = () => {
    // broucher pdf
  const openPdfInNewTab = () => {
    // Replace 'path_to_your_pdf.pdf' with the actual path to your PDF file
    const pdfUrl = `/tf_broucher/tf.pdf`;
    
    // Open the PDF in a new tab
    window.open(pdfUrl, '_blank');
  };
  return <div>
    <div>
    <style>{`
        .transformer {
            display: flex;
            flex-direction: column;
            padding: 0 10px;
        }

        .transformer img {
            width: 100%;
            height: auto;
        }
        
 .transformer .broucher-btn{
    background-color: #0056b3;
        color: white;
        padding: 15px 30px;
        border: none;
        border-radius: 45px;
        cursor: pointer;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 10px;
        width: auto;
        max-width: 200px;
        margin-left: auto;
        margin-right: auto;
}

 .transformer .broucher-btn:hover{
    background-color: grey;
}

        .transformer h1 {
            text-align: left;
            padding-left: 20px;
            margin-top: 10px;
        }

        .transformer li {
            text-align: left;
        }

        .transformer table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 50px;
        }


        /* Responsive Styles */
@media (max-width: 768px) {
    .transformer h1 {
        padding-left: 10px;
        font-size: 1.5rem; /* Adjusts heading size for smaller screens */
    }

    .transformer li {
        font-size: 14px; /* Adjusts list item text size */
    }

    .transformer .broucher-btn {
        font-size: 14px;
        padding: 12px 24px; /* Adjusts button size for tablets */
    }

    .transformer table {
        display: block;
        width: 100%;
        overflow-x: auto; /* Adds horizontal scrolling for wide tables on smaller screens */
    }

    .transformer th, td {
        font-size: 11px; /* Reduces table cell font size */
        padding: 5px; /* Adjusts padding inside table cells */
    }
}

@media (max-width: 480px) {
    .transformer h1 {
        padding-left: 5px;
        font-size: 1.2rem; /* Further reduces heading size for mobile */
    }

    .transformer li {
        font-size: 12px; /* Adjusts list item text size for mobile */
    }

    .transformer .broucher-btn {
        font-size: 12px;
        padding: 10px 20px; /* Adjusts button size for mobile */
    }

    .transformer table {
        display: block;
        width: 100%;
        overflow-x: auto; /* Allows scrolling for wide tables on small screens */
    }

    .transformer th, td {
        font-size: 10px; /* Reduces table cell font size further for mobile */
        padding: 4px; /* Adjusts padding for smaller screens */
    }
}
      `}</style>
    </div>
    <div className='transformer'>
    <img src={tf} alt="" />
    <button className="broucher-btn" onClick={openPdfInNewTab}>Download <br /> Broucher PDF</button>
    <h1 className='specs'>Specifications</h1>
    <table>
        <thead>
            <tr>
                <th>Capacity</th>
                <th>10KVA</th>
                <th>15KVA</th>
                <th>20KVA</th>
                <th>30KVA</th>
                <th>45KVA</th>
                <th>60KVA</th>
                <th>70KVA</th>
                <th>100KVA</th>
                <th>120KVA</th>
                <th>150KVA</th>
                <th>200KVA</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Input voltage</td>
                <td colspan="11">1-Phase and 3-Phase, 4 wire 380V (other voltages can be customized)</td>
            </tr>
            <tr>
                <td>Output voltage</td>
                <td colspan="11">1-Phase and 3-Phase, 4 wire 200V/220V (other voltages can be customized)</td>
            </tr>
            <tr>
                <td>Frequency</td>
                <td colspan="11">50-60Hz</td>
            </tr>
            <tr>
                <td>Load current</td>
                <td>21A</td>
                <td>31A</td>
                <td>42A</td>
                <td>63A</td>
                <td>94A</td>
                <td>127A</td>
                <td>158A</td>
                <td>210A</td>
                <td>252A</td>
                <td>315A</td>
                <td>420A</td>
            </tr>
            <tr>
                <td>Operating environment</td>
                <td colspan="11">Temperature:-20ºC-45ºC, humidity 0-95% with dew</td>
            </tr>
            <tr>
                <td>Dimension (mm)</td>
                <td>430x260x360</td>
                <td>500x300x440</td>
                <td>500x300x440</td>
                <td>550x350x530</td>
                <td>700x450x630</td>
                <td>700x450x630</td>
                <td>700x450x630</td>
                <td>950x650x950</td>
                <td>950x650x950</td>
                <td>950x650x950</td>
                <td>950x650x950</td>
            </tr>
            <tr>
                <td>Weight (kg)</td>
                <td>38</td>
                <td>54</td>
                <td>59</td>
                <td>88</td>
                <td>132</td>
                <td>143</td>
                <td>162</td>
                <td>200</td>
                <td>250</td>
                <td>319</td>
                <td>350</td>
            </tr>
        </tbody>
    </table>
    </div>
  </div>;
};

export default Transformer;
